export default{
  "current_catalog":"iastate_catalog"
}
